import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudcustodian = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "svg3355",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 157.5 157.3",
	style: { enableBackground: "new 0 0 157.5 157.3" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n	.st1{clip-path:url(#SVGID_2_);}\n	.st2{fill:url(#path3453_1_);}\n	.st3{fill:#87752E;}\n"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "g3363",
		transform: "matrix(1.25,0,0,-1.25,0,236.25)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "g3365",
				transform: "translate(88.8357,84.5112)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "path3367",
					className: "st0",
					d: "M-9,27.2l-16.9-9.3l-17,9.6v19.2l17,9.7L-9,47.6V27.2z M-8.9,66.1l-16.9,9.7l-17-9.7l-16.9,9.8 V17.4l34.1-19.2L8,17.4l0.4,58.5C8.4,75.9-8.9,66.1-8.9,66.1z"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "g3433",
				children: /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
						id: "SVGID_1_",
						d: "M0,126.2c0-34.8,28.2-63,63-63l0,0c34.8,0,63,28.2,63,63l0,0c0,34.8-28.2,63-63,63l0,0 C28.2,189.2,0,161,0,126.2"
					}) }),
					/* @__PURE__ */ _jsx("clipPath", {
						id: "SVGID_2_",
						children: /* @__PURE__ */ _jsx("use", {
							xlinkHref: "#SVGID_1_",
							style: { overflow: "visible" }
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "g3435",
						className: "st1",
						children: /* @__PURE__ */ _jsx("g", {
							id: "g3441",
							children: /* @__PURE__ */ _jsxs("g", {
								id: "g3443",
								children: [/* @__PURE__ */ _jsxs("linearGradient", {
									id: "path3453_1_",
									gradientUnits: "userSpaceOnUse",
									x1: -286.6233,
									y1: 22.3334,
									x2: -285.6233,
									y2: 22.3334,
									gradientTransform: "matrix(0 206.4569 206.4569 0 -4547.8828 59153.9961)",
									children: [
										/* @__PURE__ */ _jsx("stop", {
											offset: 0,
											style: { stopColor: "#F79422" }
										}),
										/* @__PURE__ */ _jsx("stop", {
											offset: .9835,
											style: { stopColor: "#F4C91D" }
										}),
										/* @__PURE__ */ _jsx("stop", {
											offset: 1,
											style: { stopColor: "#F4C91D" }
										})
									]
								}), /* @__PURE__ */ _jsx("path", {
									id: "path3453",
									className: "st2",
									d: "M0,126.2c0-34.8,28.2-63,63-63l0,0c34.8,0,63,28.2,63,63l0,0c0,34.8-28.2,63-63,63l0,0 C28.2,189.2,0,161,0,126.2"
								})]
							})
						})
					})
				] })
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "g3455",
				children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
					id: "g3457",
					children: [
						/* @__PURE__ */ _jsx("g", {
							id: "g3463",
							transform: "translate(74.5551,128.4795)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3465",
								className: "st0",
								d: "M-9,27.2l12-6.9V6.4l-12,6.9V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3467",
							transform: "translate(57.7491,121.5353)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3469",
								className: "st0",
								d: "M-9,27.2l12,6.9V20.2l-12-6.9V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3471",
							transform: "translate(40.9432,128.4792)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3473",
								className: "st0",
								d: "M-9,27.2l12-6.9V3.6L-9-3.3V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3475",
							transform: "translate(40.9432,92.4265)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3477",
								className: "st0",
								d: "M-9,27.2l12,6.9V20.2l-12-6.9V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3479",
							transform: "translate(69.7776,59.1304)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3481",
								className: "st0",
								d: "M-9,27.2l-26.4,15.3l12,6.9L-9,41.1V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3483",
							transform: "translate(74.5551,59.1304)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3485",
								className: "st0",
								d: "M-9,27.2v13.9l14.4,8.3l12-6.9L-9,27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3487",
							transform: "translate(103.3884,78.5369)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3489",
								className: "st0",
								d: "M-9,27.2l-12,6.9V48l12-6.9V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3491",
							transform: "translate(103.3884,97.9427)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3493",
								className: "st0",
								d: "M-9,27.2l-12,6.9v16.6l12,6.9V27.2z"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "g3495",
							transform: "translate(103.3884,97.9427)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "path3497",
								className: "st3",
								d: "M-9,27.2l-12,6.9v16.6l12,6.9V27.2z M-9,7.8l-12,6.9v13.9l12-6.9V7.8z M-37.8-11.6V2.3 l14.4,8.3l12-6.9L-37.8-11.6z M-25.8,28.6V14.7l-12-6.9v13.9L-25.8,28.6z M-52.2,32.8l12,6.9l12-6.9l-12-6.9L-52.2,32.8z  M-42.6,7.8l-12,6.9v13.9l12-6.9V7.8z M-42.6-11.6L-69.1,3.6l12,6.9l14.4-8.3C-42.6,2.3-42.6-11.6-42.6-11.6z M-71.4,21.7 l12,6.9V14.7l-12-6.9V21.7z M-71.4,57.7l12-6.9V34.1l-12-6.9V57.7z M-54.6,50.8l12,6.9V43.8l-12-6.9V50.8z M-37.8,57.7l12-6.9 V36.9l-12,6.9V57.7z M-23.4,54.9l-16.8,9.7L-57,54.9L-76.2,66V2.3l36-20.8l36,20.8V66C-4.2,66-23.4,54.9-23.4,54.9z"
							})
						})
					]
				}) })
			})
		]
	})]
});
export default SvgCloudcustodian;
